import React from 'react';
import { CONTACT, techPrepList } from '../../data/navigation';
interface TechAssistCalloutProps {
  showPrepList?: boolean;
  location: string;
}

/** Technical assistance line — featured on technical, application and
 *  safety pages per the customer's request. */
export function TechAssistCallout({
  showPrepList = false,
  location
}: TechAssistCalloutProps) {
  return <aside aria-labelledby={`tech-assist-${location}`} className="rp-grid-lines-dark border-t-2 border-copper bg-graphite" data-id="element-580" data-mp="3gtx3a67rqci2">
      <div className={`grid gap-8 p-6 sm:p-8 lg:p-10 ${showPrepList ? 'lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:gap-14' : ''}`} data-id="element-581" data-mp="3lu2trj2axsyk">
        <div data-id="element-582" data-mp="3ulv47trbt235">
          <p className="font-mono text-[10px] tracking-label text-copper" data-id="element-583" data-mp="3ullf08e3uyyi">
            TECHNICAL ASSISTANCE
          </p>
          <h2 id={`tech-assist-${location}`} className="mt-3 max-w-[28ch] font-display text-[clamp(1.3rem,2.2vw,1.75rem)] font-medium leading-snug text-white" data-id="element-584" data-mp="2y2xilh7b3oul">
            {CONTACT.techAssistSentence}
          </h2>
          <a href={CONTACT.techPhoneHref} data-analytics="phone-click" data-analytics-line="technical" data-analytics-location={location} className="mt-6 inline-flex min-h-[48px] items-center font-mono text-[clamp(1.5rem,3vw,2rem)] text-white underline decoration-copper decoration-2 underline-offset-[6px] transition-colors duration-150 ease-precise hover:text-cta" data-id="element-585" data-mp="3lw0es9tegq2m">
            {CONTACT.techPhoneLabel}
          </a>
          <p className="mt-3 text-[14px] leading-relaxed text-aluminum" data-id="element-586" data-mp="2y6649ywjzdlj">
            End users are welcome to call. For pricing and availability, call
            sales at{' '}
            <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-line="sales" data-analytics-location={location} className="whitespace-nowrap text-white underline decoration-copper underline-offset-2 hover:text-cta" data-id="element-587" data-mp="2t97bbjomlcox">
              {CONTACT.phoneLabel}
            </a>
            .
          </p>
        </div>
        {showPrepList ? <div className="border-t border-white/10 pt-6 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-588" data-mp="2byaee0mooh3o">
            <h3 className="font-mono text-[10px] tracking-label text-aluminum/80" data-id="element-589" data-mp="2gwbymovuimgq">
              HAVE THIS READY WHEN YOU CALL
            </h3>
            <ul className="mt-4 divide-y divide-white/10 border-y border-white/10" data-id="element-590" data-mp="34n7kz6hj8pgl">
              {techPrepList.map(item => <li key={item} className="flex items-start gap-3 py-2.5 text-[14.5px] text-aluminum" data-id="element-591" data-mp="2uoa0qfr53i3e">
                  <span aria-hidden="true" className="mt-2.5 h-px w-3 shrink-0 bg-copper" data-id="element-592" data-mp="2zm1u7e7fnc9p" />
                  {item}
                </li>)}
            </ul>
          </div> : null}
      </div>
    </aside>;
}